// ✅ LogicGame.jsx - Brainy Logic Verbal Puzzle Game

import React, { useState, useEffect, useRef } from 'react';
import { auth, db } from '../../firebase';
import { doc, getDoc, updateDoc, setDoc } from 'firebase/firestore';
import { onAuthStateChanged } from 'firebase/auth';
import Navbar from '../../components/Navbar';
import { Toaster, toast } from 'react-hot-toast';
import Confetti from 'react-confetti';
import { useWindowSize } from '@uidotdev/usehooks';
import { useNavigate } from 'react-router-dom';

const questionBank = [
  // Level 1 (Easy)
  { level: 1, question: "Which one can fly?", options: ["Dog", "Fish", "Bird", "Cat"], answer: "Bird" },
  { level: 1, question: "Which is a vegetable?", options: ["Apple", "Carrot", "Banana", "Grape"], answer: "Carrot" },
  { level: 1, question: "What color is the sky?", options: ["Green", "Blue", "Red", "Yellow"], answer: "Blue" },
  { level: 1, question: "Which animal meows?", options: ["Dog", "Cat", "Cow", "Bird"], answer: "Cat" },
  { level: 1, question: "Which one is bigger?", options: ["Mouse", "Elephant", "Ant", "Bee"], answer: "Elephant" },
  { level: 1, question: "Which is used for writing?", options: ["Spoon", "Pencil", "Plate", "Bottle"], answer: "Pencil" },
  { level: 1, question: "Which one swims?", options: ["Elephant", "Fish", "Horse", "Cow"], answer: "Fish" },
  { level: 1, question: "Which fruit is sour?", options: ["Lemon", "Apple", "Banana", "Grape"], answer: "Lemon" },
  { level: 1, question: "Which one has wheels?", options: ["Car", "Boat", "Plane", "Helicopter"], answer: "Car" },
  { level: 1, question: "Which is full of pages?", options: ["Book", "Table", "Shoe", "Cup"], answer: "Book" },
  { level: 1, question: "Which one is the odd one out?", options: ["Dog", "Cat", "Apple", "Cow"], answer: "Apple" },
  { level: 1, question: "What comes next in the sequence: 2, 4, 6, ?", options: ["7", "8", "9", "10"], answer: "8" },
  { level: 1, question: "Which is the shortest?", options: ["Tree", "Grass", "Building", "Mountain"], answer: "Grass" },
  { level: 1, question: "Which animal barks?", options: ["Cat", "Cow", "Dog", "Goat"], answer: "Dog" },
  { level: 1, question: "Which one is not a color?", options: ["Blue", "Red", "Chair", "Green"], answer: "Chair" },
  // Level 2 (Medium)
  { level: 2, question: "Find the odd one out: Circle, Square, Triangle, Apple", options: ["Circle", "Square", "Triangle", "Apple"], answer: "Apple" },
  { level: 2, question: "What is next in pattern: 2,3,5,7,11,?", options: ["12","13","14","15"], answer: "13" },
  { level: 2, question: "Which word is opposite of 'Night'?", options:["Day","Light","Dark","Moon"], answer:"Day" },
  { level: 2, question: "Complete sequence: Jan, Feb, Mar, ?", options: ["Apr","May","Jun","Jul"], answer: "Apr" },
  { level: 2, question: "Which is not a fruit?", options: ["Tomato","Banana","Orange","Grapes"], answer:"Tomato" },
  { level: 2, question: "Find the pattern: one, two, three, ?", options: ["four","five","six","seven"], answer: "four" },
  { level: 2, question: "Which shape has 4 equal sides and angles?", options:["Rectangle","Square","Triangle","Circle"], answer:"Square" },
  { level: 2, question: "Which does not belong: Pen, Paper, Eraser, Table", options:["Pen","Paper","Eraser","Table"], answer:"Table" },
  { level: 2, question: "What comes next: 10, 20, 30, ?", options:["35","40","45","50"], answer:"40" },
  { level: 2, question: "Which is a mammal?", options:["Shark","Dolphin","Trout","Salmon"], answer:"Dolphin" },
  { level: 2, question: "Find the pattern: Mon, Tue, Wed, ?", options: ["Thu", "Fri", "Sat", "Sun"], answer: "Thu" },
  { level: 2, question: "Which does not belong to the group?", options: ["Pen", "Pencil", "Eraser", "Spoon"], answer: "Spoon" },
  { level: 2, question: "What is the next number: 5, 10, 20, ?", options: ["25", "35", "40", "30"], answer: "40" },
  { level: 2, question: "Odd one out: Banana, Mango, Orange, Tomato", options: ["Banana", "Mango", "Tomato", "Orange"], answer: "Tomato" },
  { level: 2, question: "What comes next: A, C, E, ?", options: ["F", "G", "H", "G"], answer: "G" },
  // Level 3 (Hard)
  { level: 3, question: "If all Bloops are Razzies and all Razzies are Lazzies, are all Bloops definitely Lazzies?", options: ["Yes", "No", "Maybe", "Depends"], answer: "Yes" },
  { level: 3, question: "Which number completes the pattern: 3, 6, 12, 24, ?", options: ["36", "40", "48", "60"], answer: "48" },
  { level: 3, question: "Which figure is different? Square, Triangle, Cube, Circle", options: ["Square", "Triangle", "Cube", "Circle"], answer: "Cube" },
  { level: 3, question: "John is taller than Sam. Sam is shorter than Alex. Who is the shortest?", options: ["John", "Sam", "Alex", "All equal"], answer: "Sam" },
  // Additional Hard questions ...
  { level: 3, question: "What comes next? 1, 4, 9, 16, ?", options: ["20", "25", "36", "49"], answer: "25" },
  { level: 3, question: "Which one doesn't belong? Knife, Fork, Spoon, Plate", options: ["Knife", "Fork", "Spoon", "Plate"], answer: "Plate" },
  { level: 3, question: "Which word does not belong? Apple, Banana, Carrot, Mango", options: ["Apple", "Banana", "Carrot", "Mango"], answer: "Carrot" },
  { level: 3, question: "Which is heavier? A kilo of cotton or a kilo of iron?", options: ["Cotton", "Iron", "Same", "None"], answer: "Same" },
  { level: 3, question: "Rearrange the letters 'N E T S' to make a word", options: ["Nest", "Sent", "Tens", "All of these"], answer: "All of these" },
  { level: 3, question: "Which shape has the most sides? Triangle, Square, Pentagon, Octagon", options: ["Triangle", "Square", "Pentagon", "Octagon"], answer: "Octagon" },
  { level: 3, question: "If Monday is the first day, what day is 10th?", options: ["Wednesday", "Thursday", "Friday", "Wednesday"], answer: "Wednesday" },
  { level: 3, question: "Choose the missing letter: A, C, E, G, ?", options: ["H", "I", "J", "K"], answer: "I" },
  { level: 3, question: "How many sides does a hexagon have?", options: ["4", "5", "6", "8"], answer: "6" },
  { level: 3, question: "If 3 cats catch 3 mice in 3 minutes, how many cats are needed to catch 100 mice in 100 minutes?", options: ["3", "100", "1", "33"], answer: "3" },
  { level: 3, question: "What comes next: J, F, M, A, M, J, ?", options: ["J", "A", "S", "O"], answer: "J" },
  { level: 3, question: "Which does not belong: Lion, Tiger, Cheetah, Cow", options: ["Lion", "Tiger", "Cheetah", "Cow"], answer: "Cow" },
  { level: 3, question: "Complete the analogy: Finger is to Hand as Toe is to ?", options: ["Foot", "Leg", "Shoe", "Nail"], answer: "Foot" },
  { level: 3, question: "Which month has 28 days?", options: ["February", "None", "All months", "December"], answer: "All months" },
  { level: 3, question: "If you rearrange the letters BARBIT, you get the name of a?", options: ["City", "River", "Animal", "Fruit"], answer: "Animal" },
  { level: 3, question: "What is the missing number? 2, 6, 12, 20, ?", options: ["28", "30", "32", "34"], answer: "30" },
  // Added Hard Questions
  { level: 3, question: "Which word is a palindrome?", options: ["Level", "World", "Logic", "Brain"], answer: "Level" },
  { level: 3, question: "What 4-letter word becomes shorter when you add two letters to it?", options: ["Long", "Short", "Wide", "Tall"], answer: "Short" },
  { level: 3, question: "If TRAIN is to TRAINER, then BOOK is to ?", options: ["Booker", "Bookly", "Booking", "Notebook"], answer: "Booker" },
  { level: 3, question: "Find the next number: 2,6,12,20,30,?", options: ["42","36","40","48"], answer: "42" },
  { level: 3, question: "Which is the odd one out: Mercury, Venus, Earth, Sun", options: ["Mercury","Venus","Earth","Sun"], answer: "Sun" },
  { level: 3, question: "Which number is missing: 5,10,20,40,?", options: ["50","60","80","100"], answer: "80" },
  { level: 3, question: "Find the hidden word: TEHCNOILG", options: ["Technology","Logic","Game","Brain"], answer: "Technology" },
  { level: 3, question: "Which follows pattern: Z,Y,X,?", options: ["V","W","U","T"], answer: "W" },
  { level: 3, question: "What comes next: 1,1,2,3,5,8,13,?", options: ["21","20","18","16"], answer: "21" },
  { level: 3, question: "Which number does not belong: 16,18,20,23,24", options: ["16","18","20","23","24"], answer: "23" }
];

export default function LogicGame() {
  const [index, setIndex] = useState(0);
  const [selected, setSelected] = useState(null);
  const [correctCount, setCorrectCount] = useState(0);
  const [timeLeft, setTimeLeft] = useState(20);
  const [gameOver, setGameOver] = useState(false);
  const [loading, setLoading] = useState(true);

  const [chronos, setChronos] = useState(0);
  const [todayPlays, setTodayPlays] = useState(0);
  const [playLimit, setPlayLimit] = useState(25);
  const [limitReached, setLimitReached] = useState(false);
  const navigate = useNavigate();
  const { width, height } = useWindowSize();
  const [isGameOver, setIsGameOver] = useState(false);


  const current = questionBank[index] || { question: '', options: [], answer: '' };

    useEffect(() => {
    if (limitReached || gameOver || loading) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          setGameOver(true);
          updateLeaderboard();
          toast.error('⏰ Time up!');
          return 0;
        }
        return prev - 1;
      });
    }, 2000);

    return () => clearInterval(timer);
  }, [index, limitReached, gameOver, loading]);

  // Guard Firestore calls until auth is ready
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setLoading(false);
        return;
      }

      try {
        const ref = doc(db, 'users', user.uid);
        const snap = await getDoc(ref);
        if (!snap.exists()) {
          setLoading(false);
          return;
        }
        const data = snap.data();

        const today = new Date().toDateString();
        if (data.logicPlaysDate !== today) {
          await updateDoc(ref, {
            logicPlays: 0,
            logicPlaysDate: today
          });
          toast.success('🧠 New day, new logic grid!');
        }

        // Active/demo access checks
        if (!data.isActive) {
          toast.error('Profile deactivated. Contact support.');
          navigate('/contact');
          return;
        }
        if (data.accessType === 'demo' && data.accessExpiry && new Date() > new Date(data.accessExpiry)) {
          toast.error('Demo expired. Please upgrade.');
          navigate('/contact');
          return;
        }

        // Load Chronos
        setChronos(data.chronos || 0);

        // Setup daily limit
        const limit = data.accessType === 'pro' ? 200 : 25;
        setPlayLimit(limit);

        // Determine today's plays without resetting on refresh
        const plays = (data.logicPlaysDate === today) ? (data.logicPlays || 0) : 0;
        setTodayPlays(plays);
        setLimitReached(plays >= limit);
      } catch (error) {
        console.error('Error loading LogicGame data:', error);
      } finally {
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, [navigate]);



  const handleChoice = async (opt) => {
    if (selected || gameOver || limitReached) return;
    setSelected(opt);
    const isCorrect = opt === current.answer;
    if (isCorrect) {
      toast.success("✅ Correct!");
      const bonus = 3;
      const newChronos = chronos + bonus;
      setChronos(newChronos);
      setCorrectCount(c => c + 1);
      const updatedPlays = todayPlays + 1;
      const today = new Date().toDateString();
      setTodayPlays(updatedPlays);
      if (updatedPlays >= playLimit) {
        setLimitReached(true);
        toast.error('🎓 You’ve reached today’s logic game limit. Come back sharper tomorrow!');
      }
      await updateDoc(doc(db, 'users', auth.currentUser.uid), {
        chronos: newChronos,
        logicPlays: updatedPlays,
        logicPlaysDate: today
      });

      setTimeout(() => {
        if (index + 1 < questionBank.length) {
          setIndex(i => i + 1);
          setSelected(null);
          setTimeLeft(Math.max(20 - Math.floor((correctCount + 1) / 3), 5));
        } else {
          setGameOver(true);
          updateLeaderboard();
        }
      }, 2000);
      return;
    }
      
   else {
      toast.error("❌ Incorrect!");
    }
    setTimeout(() => {
        setGameOver(true);
        updateLeaderboard();
      }, 2000);
      
  };

  const updateLeaderboard = async () => {
    const uid = auth.currentUser?.uid;
    if (!uid) return;
    const lbRef = doc(db, 'leaderboard_master', uid);
    const lbSnap = await getDoc(lbRef);
    const profileRef = doc(db, 'users', uid);
    const profileSnap = await getDoc(profileRef);
    const name = profileSnap.exists() ? profileSnap.data().name || 'Brainy Player' : 'Brainy Player';
    const chronosNow = chronos;

    if (lbSnap.exists()) {
      const prev = lbSnap.data();
      await updateDoc(lbRef, {
        name,
        chronos: chronosNow,
        bestLogicScore: Math.max(prev.bestLogicScore || 0, correctCount),
        bestNumberMemoryLevel: prev.bestNumberMemoryLevel || 0,
        bestFocusGameStreak: prev.bestFocusGameStreak || 0,
        bestSynonymWords: prev.bestSynonymWords || 0,
        bestMathSprintScore: prev.bestMathSprintScore || 0,
        lastPlayed: new Date().toDateString()
      });
    } else {
      await setDoc(lbRef, {
        name,
        chronos: chronosNow,
        bestLogicScore: correctCount,
        bestNumberMemoryLevel: 0,
        bestFocusGameStreak: 0,
        bestSynonymWords: 0,
        bestMathSprintScore: 0,
        lastPlayed: new Date().toDateString()
      });
    }
  };

  const restart = () => {
    setIndex(0);
    setSelected(null);
    setCorrectCount(0);
    setGameOver(false);
    setTimeLeft(20);
  };

  return (
    <>
      <Navbar />
      <Toaster position="top-center" />
      {gameOver && <Confetti width={width} height={height} />}

      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-100 p-6 flex flex-col items-center justify-center">
        <div className="bg-white p-6 rounded-xl shadow-xl w-full max-w-md text-center space-y-4">
          {limitReached && (
            <div className="text-sm text-red-600 font-semibold bg-red-50 p-2 rounded-md border border-red-300">
              🎯 You've reached today’s Logic Game limit.<br />Take a break and return tomorrow with sharper logic!
            </div>
          )}
          <h1 className="text-2xl font-bold text-purple-700">🧠 Logic Grid</h1>

          <div className="text-sm font-semibold text-gray-700">
            ⏳ Time Left: {timeLeft}s
            <div className="w-full bg-gray-200 rounded-full mt-1 h-2">
              <div
                className={`h-full rounded-full transition-all duration-500 ${timeLeft > 20 ? 'bg-green-500' : timeLeft > 5 ? 'bg-yellow-400' : 'bg-red-500'}`}
                style={{ width: `${(timeLeft / 20) * 100}%` }}
              />
            </div>
          </div>

          {!gameOver ? (
            <>
              <p className="text-lg text-gray-700 font-semibold">{current.question}</p>
              <div className="grid grid-cols-1 gap-4">
                {current.options.map((opt, i) => (
                  <button
                    key={i}
                    onClick={() => handleChoice(opt)}
                    className={`p-3 rounded-lg text-lg font-medium shadow transition duration-200
                      ${selected === opt ? (opt === current.answer ? 'bg-green-400 text-white' : 'bg-red-400 text-white') : 'bg-purple-100 hover:bg-purple-200'}`}
                    disabled={!!selected}
                  >{opt}</button>
                ))}
              </div>
            </>
          ) : (
            <div className="text-center space-y-4">
              <p className="text-lg font-semibold text-purple-700">🎉 You’ve completed the logic challenge!</p>
              <p className="text-sm text-gray-600">Correct Answers: {correctCount}</p>
              <p className="text-sm text-green-600">Chronos Earned: {correctCount * 3}</p>
              <button
                onClick={restart}
                className="px-4 py-2 bg-purple-600 text-white rounded hover:bg-purple-700"
              >🔁 Play Again</button>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
